// extracted by mini-css-extract-plugin
export default {"tooltip":"LineChart_tooltip__hG84s"};